import { StaticContext } from '@sm/webassets';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { Table } from '@wds/table';
import { Typography } from '@wds/typography';

import getPlanLabelForFeature from './getPlanLabelForFeature';

const AppTable = ({ privateTable }) => {
  const {
    environment: { domain },
    user,
  } = useContext(StaticContext);
  const location = useLocation();

  const planLabel = () => {
    if (user.id === '1' || !user.user_data) {
      return (
        <a
          href={`https://www.${domain}.com/user/sign-in/?ep=${location.href}&amp;ut_source=dev_portal&amp;ut_source2=private_apps`}
        >
          Sign In to View Plan
        </a>
      );
    }
    if (user.user_data.features.private_apps) {
      return <span>Your current plan</span>;
    }

    return (
      <a href={`https://www.${domain}.com/pricing/`} target="_blank" rel="noreferrer">
        {getPlanLabelForFeature(user.user_data, 'private_apps')}
      </a>
    );
  };

  const col1 = [
    <Typography>Criteria</Typography>,
    <Typography>
      <strong>
        Eligible for the <a href={`https://www.${domain}.com/apps`}> App Directory </a>
      </strong>
    </Typography>,
    <Typography>
      <strong>SurveyMonkey account needed by Developer</strong>
    </Typography>,
    <Typography>
      <strong>Plan needed to utilize app functionality</strong>
    </Typography>,
    <Typography>
      <strong>Who purchases user&apos;s SM accounts</strong>
    </Typography>,
    <Typography>
      <strong>How many accounts can access the app</strong>
    </Typography>,
    <Typography>
      <strong>API call limits*</strong>
    </Typography>,
    <Typography>
      <strong>Requires approval before launching</strong>
    </Typography>,
  ];

  const col2 = [
    <Typography>Public Apps</Typography>,
    <Typography>Yes</Typography>,
    <Typography>Any</Typography>,
    <Typography>SurveyMonkey account needs to be an enduser of the app</Typography>,
    <Typography>End User</Typography>,
    <Typography>Unlimited</Typography>,
    <Typography>Unlimited</Typography>,
    <Typography>Yes </Typography>,
  ];

  const col3 = [
    <Typography>Private Apps</Typography>,
    <Typography>No</Typography>,
    <Typography>{planLabel()}</Typography>,
    <Typography>{planLabel()}</Typography>,
    <Typography>Developer</Typography>,
    <Typography>
      One SurveyMonkey account or one <a href={`https://help.${domain}.com/articles/en_US/kb/Groups`}>Team</a>
    </Typography>,
    <Typography>
      500/day, more available (<a href={`https://www.${domain}.com/enterprise/`}>Contact sales</a>)
    </Typography>,
    <Typography>No</Typography>,
  ];

  const firstCol = privateTable ? col3 : col2;
  const secondCol = privateTable ? col2 : col3;

  return (
    <Table data-testid="AppTable">
      <Table.Header>
        <Table.Row>
          <Table.Cell>{col1[0]}</Table.Cell>
          <Table.Cell data-testid="AppTable__FirstCol">{firstCol[0]}</Table.Cell>
          <Table.Cell>{secondCol[0]}</Table.Cell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            <Typography>{col1[1]}</Typography>
          </Table.Cell>
          <Table.Cell>{firstCol[1]}</Table.Cell>
          <Table.Cell>{secondCol[1]}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{col1[2]}</Table.Cell>
          <Table.Cell>{firstCol[2]}</Table.Cell>
          <Table.Cell>{secondCol[2]}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{col1[3]}</Table.Cell>
          <Table.Cell>{firstCol[3]}</Table.Cell>
          <Table.Cell>{secondCol[3]}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{col1[4]}</Table.Cell>
          <Table.Cell>{firstCol[4]}</Table.Cell>
          <Table.Cell>{secondCol[4]}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{col1[5]}</Table.Cell>
          <Table.Cell>{firstCol[5]}</Table.Cell>
          <Table.Cell>{secondCol[5]}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{col1[6]}</Table.Cell>
          <Table.Cell>{firstCol[6]}</Table.Cell>
          <Table.Cell>{secondCol[6]}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{col1[7]}</Table.Cell>
          <Table.Cell>{firstCol[7]}</Table.Cell>
          <Table.Cell>{secondCol[7]}</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

AppTable.propTypes = {
  privateTable: PropTypes.bool,
};

AppTable.defaultProps = {
  privateTable: false,
};

export default AppTable;
